module.exports = __webpack_public_path__ + "img/demo.1701c0df.gif";